// Auto-generated build info - DO NOT EDIT MANUALLY
// Generated by scripts/generate-version.sh
export const BUILD_VERSION = {
  id: '1781981951',
  timestamp: '2026-06-20 18:59:11 UTC',
  git: '231329c-dirty',
  branch: 'claude/continue-project-dev-V23fH',
};
